
		<router-outlet></router-outlet>

<ngx-spinner>
  <p style="font-size: 1rem; color: white">Loading...</p>
</ngx-spinner>